import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsUp20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconThumbsUp20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 9.553h-.5a1 1 0 0 0-1 1V14.5a1 1 0 0 0 1 1H5zM6.5 15.5h7.001a1 1 0 0 0 .896-.555l1.963-3.947a1 1 0 0 0-.896-1.445h-4.749l.14-1.629.296-3.433L6.564 9.11l-.064.064zm6.146-10.88-.167 1.933-.129 1.5h3.115c1.856 0 3.064 1.95 2.238 3.613l-1.963 3.947A2.5 2.5 0 0 1 13.5 17h-9A2.5 2.5 0 0 1 2 14.5v-3.947a2.5 2.5 0 0 1 2.5-2.5h1l4.587-4.62c.988-.994 2.679-.21 2.559 1.186"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsUp20);
